const types = {
  GET_PASSAGEPASS_DATA: "GET_PASSAGEPASS_DATA",
  FETCH_WAIT_LIST: "FETCH_WAIT_LIST",
  FETCH_WAIT_EXPORT_LIST: "FETCH_WAIT_EXPORT_LIST",
};

export default types;
